import { render, staticRenderFns } from "./Damage-Detail.vue?vue&type=template&id=4d75b4fa"
import script from "./Damage-Detail.vue?vue&type=script&lang=js"
export * from "./Damage-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports